/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_ReasonInputs */

const cs_viewings_reason = /** @type {(inputs: Viewings_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Důvod nekoupení`)
};

const en_viewings_reason = /** @type {(inputs: Viewings_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason not purchased`)
};

/**
* | output |
* | --- |
* | "Reason not purchased" |
*
* @param {Viewings_ReasonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_reason = /** @type {((inputs?: Viewings_ReasonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_ReasonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_reason(inputs)
	return cs_viewings_reason(inputs)
});